import { SetBillingAccountRatesBodyDto } from 'app/API';
import { TRatesState } from '../types/TRatesState';

export const buildSetBillingAccountRatesRequestBody = (rates: TRatesState): SetBillingAccountRatesBodyDto => ({
  realTimeRateType: rates.realTimeRateType,
  realTimeRate: Number(rates.realTimeRate),
  postProcessingRateType: rates.postProcessingRateType,
  postProcessingRate: Number(rates.postProcessingRate),
  partialUnlockRateType: rates.partialUnlockRateType,
  partialUnlockRate: Number(rates.partialUnlockRate),
  fullUnlockRateType: rates.fullUnlockRateType,
  fullUnlockChargeType: rates.fullUnlockChargeType,
  fullUnlockRate: Number(rates.fullUnlockRate),
  enhancedOnDemandRateType: rates.enhancedOnDemandRateType,
  enhancedOnDemandRate: Number(rates.enhancedOnDemandRate),
  attorneyConnectFeeRateType: rates.attorneyConnectFeeRateType,
  attorneyConnectFeeRate: Number(rates.attorneyConnectFeeRate),
  attorneyInviteFeeRateType: rates.attorneyInviteFeeRateType,
  attorneyInviteFeeRate: Number(rates.attorneyInviteFeeRate),
});
